export default __webpack_public_path__ + "4ee96395e07a04577aabb87e1cba8977.ttf";